<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>GIẤY ĐỀ NGHỊ THAY ĐỔI THÔNG TIN ĐƠN VỊ CHẤP NHẬN THANH TOÁN</b>
      </p>
      <p class="txt-center">( Ngày: {{ currentDate }} )</p>
      <p class="txt-center">
        <b v-if="checkCreatedDateNganluong(dataAppendix)"
          >Kính gửi: Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng</b
        >
        <b v-else>Kính gửi: Công ty Cổ phần Công nghệ Vi Mô</b>
      </p>
      <p class="flex fonsize-16 txt-tranf">
        <span class="nowrap"> <b>ĐƠN VỊ CHẤP NHẬN THANH TOÁN (ĐVCNTT):</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>

      <div class="form form-ext">
        <p>
          <span>Địa chỉ: </span>
          <mark>
            {{ customerInfo.address }}, {{ customerInfo.district }},
            {{ customerInfo.city }}
          </mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Email: {{ customerInfo.email }} </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại ngân hàng:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p class="m-b-30">
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>
        Căn cứ vào Hợp đồng hợp tác chấp nhận thanh toán số
        <span
          ><mark>{{
            dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
          }}</mark></span
        >
        ký ngày
        <mark v-if="dataAppendix?.isNganluongContract">
          {{ dataAppendix?.dateSignContract | formatDate }}</mark
        >
        <mark v-else>{{
          dataContract.effectiveFromDTO
            ? dataContract.effectiveFromDTO
            : dataContract.dateSign | formatDate
        }}</mark>
        giữa
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng'
            : 'Công ty Cổ phần Công nghệ Vi Mô'
        }}
        và ĐVCNTT, ĐVCNTT đề nghị thay đổi một số thông tin được thể hiện dưới đây. Giấy đề nghị
        thay đổi thông tin này là một phần không thể tách rời của Hợp đồng chấp nhận thanh toán đã
        ký kết.
      </p>
      <p>
        <b
          >ĐVCNTT muốn thay đổi một số thông tin (Các thông tin có hiệu lực từ ngày
          ...../...../..........)</b
        >
      </p>
      <p><i>(Vui lòng đánh dấu X vào nội dung đăng ký thay đổi)</i></p>

      <ol>
        <p>
          <input
            class="non-interactive-checkbox"
            type="checkbox"
            :checked="appendixChange.arrTypeChanges.includes('CHANGE_MPOS_ACCOUNT_INFO')"
          />
          Thông tin đăng ký mở tài khoản mPOS
        </p>
        <p>
          <input
            class="non-interactive-checkbox"
            type="checkbox"
            :checked="appendixChange.arrTypeChanges.includes('CHANGE_REPRESENT_INFO')"
          />
          Thông tin người đại diện ký Hợp đồng với
          {{
            checkCreatedDateNganluong(dataAppendix)
              ? 'Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng'
              : 'Công ty Cổ phần Công nghệ Vi Mô'
          }}
        </p>
        <p>
          <input
            class="non-interactive-checkbox"
            type="checkbox"
            :checked="appendixChange.arrTypeChanges.includes('CHANGE_BANK_ACCOUN_INFO')"
          />
          Thông tin tài khoản ngân hàng
        </p>
        <p>
          <input
            class="non-interactive-checkbox"
            type="checkbox"
            :checked="
              appendixChange.arrTypeChanges?.includes('CHANGE_BUSINESS_REGISTRATION') ||
              appendixChange.arrTypeChanges?.includes('CHANGE_BUSINESS_REGISTRATION_INFO')
            "
          />
          Thay đổi Thông tin trên Giấy chứng nhận đăng ký doanh nghiệp/Giấy chứng nhận đăng ký hộ
          kinh doanh, gồm các trường hợp sau:
        </p>
        <ol>
          <li>
            <p>
              <input
                class="non-interactive-checkbox"
                type="checkbox"
                :checked="
                  appendixChange.arrTypeChanges?.includes('CHANGE_BUSINESS_REGISTRATION_INFO')
                "
              />
              Thông tin Người đại diện theo pháp luật của công ty/Chủ hộ kinh doanh
            </p>
            <p>
              <input
                class="non-interactive-checkbox"
                type="checkbox"
                :checked="appendixChange.arrTypeChanges?.includes('CHANGE_BUSINESS_REGISTRATION')"
              />
              Thông tin địa chỉ trụ sở
            </p>
            <p>
              <input class="non-interactive-checkbox" type="checkbox" :checked="false" /> Thông tin
              khác (nếu có, vui lòng điền chi tiết):
            </p>
            <p>
              ...............................................................................................................................................................................
            </p>
          </li>
        </ol>
      </ol>
      <p>Chi tiết nội dung thay đổi cụ thể như sau:</p>
      <p><i>(Chỉ điền phần nội dung tương ứng với phần đã đánh dấu X nêu trên) </i></p>

      <p>&nbsp;</p>
      <ol class="form-style1">
        <li
          v-if="
            appendixChange.representMobile ||
            appendixChange.representEmail ||
            appendixChange.representName ||
            appendixChange.representPosition ||
            appendixChange.accountEmail ||
            appendixChange.accountMobile
          "
        >
          <h1>THÔNG TIN NGƯỜI ĐẠI DIỆN KÝ HỢP ĐỒNG VỚI BÊN A</h1>
          <div>
            <ol>
              <li
                v-if="
                  appendixChange.arrTypeChanges &&
                  appendixChange.arrTypeChanges.includes('CHANGE_MPOS_ACCOUNT_INFO')
                "
              >
                <span class="txt-bold"> Thay đổi email, số điện thoại đăng ký: </span>
                <div class="table-responsive p-r-60">
                  <table>
                    <thead>
                      <tr class="bg-head">
                        <th><b>Nội dung</b></th>
                        <th><b>Thông tin hiện tại</b></th>
                        <th><b>Thông tin thay đổi</b></th>
                        <th><b>Lưu ý (Nếu có)</b></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="txt-center" v-if="appendixChange.accountEmail">
                        <td class="txt-center">Email</td>
                        <td class="txt-center">
                          {{ appendixChange.accountEmail.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.accountEmail.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.accountMobile">
                        <td class="txt-center">Số điện thoại</td>
                        <td class="txt-center">
                          {{ appendixChange.accountMobile.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.accountMobile.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
              <li v-if="appendixChange.typeChangeRepresent === 'CHANGE_NEW_REPRESENT'">
                <span class="txt-bold"> Thay đổi người đại diện ký Hợp đồng mới: </span>
                <div class="table-responsive p-r-60">
                  <table>
                    <thead>
                      <tr class="bg-head">
                        <th><b>Nội dung</b></th>
                        <th><b>Thông tin hiện tại</b></th>
                        <th><b>Thông tin thay đổi</b></th>
                        <th><b>Lưu ý (Nếu có)</b></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="txt-center" v-if="appendixChange.representName">
                        <td class="txt-center">Họ tên</td>
                        <td class="txt-center">
                          {{ appendixChange.representName.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representName.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representEmail">
                        <td class="txt-center">Email</td>
                        <td class="txt-center">
                          {{ appendixChange.representEmail.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representEmail.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representMobile">
                        <td class="txt-center">Số điện thoại</td>
                        <td class="txt-center">
                          {{ appendixChange.representMobile.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representMobile.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representPosition">
                        <td class="txt-center">Chức vụ</td>
                        <td class="txt-center"></td>
                        <td class="txt-center">
                          {{ appendixChange.representPosition | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representPassport">
                        <td class="txt-center">Số CMND/ CCCD</td>
                        <td class="txt-center">
                          {{ appendixChange.representPassport.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representPassport.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representAuthContractNumber">
                        <td class="txt-center">Số giấy Ủy quyền (nếu có)</td>
                        <td class="txt-center"></td>
                        <td class="txt-center">
                          {{ appendixChange.representAuthContractNumber | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
              <li v-if="appendixChange.typeChangeRepresent === 'CHANGE_CURRENT_REPRESENT_INFO'">
                <span class="txt-bold"> Thay đổi thông tin của người đại diện hiện tại </span>
                <div class="table-responsive p-r-60">
                  <table>
                    <thead>
                      <tr class="bg-head">
                        <th><b>Nội dung</b></th>
                        <th><b>Thông tin hiện tại</b></th>
                        <th><b>Thông tin thay đổi</b></th>
                        <th><b>Lưu ý (Nếu có)</b></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="txt-center" v-if="appendixChange.representName">
                        <td class="txt-center">Họ tên</td>
                        <td class="txt-center">
                          {{ appendixChange.representName.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representName.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representEmail">
                        <td class="txt-center">Email</td>
                        <td class="txt-center">
                          {{ appendixChange.representEmail.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representEmail.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representMobile">
                        <td class="txt-center">Số điện thoại</td>
                        <td class="txt-center">
                          {{ appendixChange.representMobile.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representMobile.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representPosition">
                        <td class="txt-center">Chức vụ</td>
                        <td class="txt-center"></td>
                        <td class="txt-center">
                          {{ appendixChange.representPosition | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representPassport">
                        <td class="txt-center">Số CMND/ CCCD</td>
                        <td class="txt-center">
                          {{ appendixChange.representPassport.oldData | checkEmpty }}
                        </td>
                        <td class="txt-center">
                          {{ appendixChange.representPassport.newData | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                      <tr class="txt-center" v-if="appendixChange.representAuthContractNumber">
                        <td class="txt-center">Số giấy Ủy quyền (nếu có)</td>
                        <td class="txt-center"></td>
                        <td class="txt-center">
                          {{ appendixChange.representAuthContractNumber | checkEmpty }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
              <ol v-if="appendixChange.representMutualRelation" class="form-style2">
                <li>
                  Mối quan hệ giữa Người đại diện hiện tại và Người đại diện mới:
                  {{ appendixChange.representMutualRelation }}
                </li>
              </ol>
            </ol>
          </div>
        </li>
        <li
          v-if="
            appendixChange.bankAccType ||
            appendixChange.holderName ||
            appendixChange.bankCityName ||
            appendixChange.branch ||
            appendixChange.accountNo
          "
        >
          <h1>THÔNG TIN TÀI KHOẢN NGÂN HÀNG</h1>
          <ol class="form-style2">
            <li>
              <div class="table-responsive p-r-60">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th><b>Nội dung</b></th>
                      <th><b>Thông tin hiện tại</b></th>
                      <th><b>Thông tin thay đổi</b></th>
                      <th><b>Lưu ý (Nếu có)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="txt-center" v-if="appendixChange.bankAccType">
                      <td class="txt-center">Loại tài khoản</td>
                      <td class="txt-center">
                        {{
                          appendixChange.bankAccType.oldData
                            | transfromMccName(configInfoChange.mcBankAccType)
                        }}
                      </td>
                      <td class="txt-center">
                        {{
                          appendixChange.bankAccType.newData
                            | transfromMccName(configInfoChange.mcBankAccType)
                        }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.accountNo">
                      <td class="txt-center">Số tài khoản</td>
                      <td class="txt-center">
                        {{ appendixChange.accountNo.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.accountNo.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.bankName">
                      <td class="txt-center">Tại ngân hàng</td>
                      <td class="txt-center">{{ appendixChange.bankName.oldData | checkEmpty }}</td>
                      <td class="txt-center">{{ appendixChange.bankName.newData | checkEmpty }}</td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.holderName">
                      <td class="txt-center">Tên Người thụ hưởng</td>
                      <td class="txt-center">
                        {{ appendixChange.holderName.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.holderName.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr
                      class="txt-center"
                      v-if="appendixChange.branch || bankConfig.includes(appendixChange.branch)"
                    >
                      <td class="txt-center">Chi nhánh</td>
                      <td class="txt-center">{{ appendixChange.branch.oldData | checkEmpty }}</td>
                      <td class="txt-center">{{ appendixChange.branch.newData | checkEmpty }}</td>
                      <td></td>
                    </tr>
                    <tr
                      class="txt-center"
                      v-if="
                        appendixChange.bankCityName ||
                        bankConfig.includes(appendixChange.bankCityName)
                      "
                    >
                      <td class="txt-center">Tỉnh thành</td>
                      <td class="txt-center">
                        {{ appendixChange.bankCityName.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.bankCityName.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
            <ol v-if="appendixChange.bankMutualRelation" class="form-style2">
              <li>
                <p>
                  Mối quan hệ giữa hai Bên thụ hưởng là: {{ appendixChange.bankMutualRelation }}
                </p>
              </li>
              <li>
                <p>
                  Vai trò/Vị trí của Người được ủy quyền nhận tiền mới là:
                  {{ appendixChange.positionAuthBank }}
                </p>
              </li>
              <p>
                <i
                  >(Lưu ý: Nếu đổi sang doanh nghiệp, hộ kinh doanh mới có cùng người đại diện theo
                  pháp luật, vui lòng bỏ qua phần này)</i
                >
              </p>
            </ol>
          </ol>
        </li>
        <li v-if="appendixChange.businessAuthoriserName || appendixChange.businessMcName">
          <h1>
            THAY ĐỔI THÔNG TIN TRÊN GIẤY CHỨNG NHẬN ĐĂNG KÝ DOANH NGHIỆP/ GIẤY CHỨNG NHẬN ĐĂNG KÝ HỘ
            KINH DOANH
          </h1>
          <p>
            Kèm theo Giấy chứng nhận đăng ký doanh nghiệp/Giấy chứng nhận đăng ký hộ kinh doanh sửa
            đổi lần
            <mark
              ><span v-if="appendixChange.businessCertAmendTimes">{{
                appendixChange.businessCertAmendTimes
              }}</span
              ><span v-else>....</span></mark
            >
            ngày
            <mark
              ><span v-if="appendixChange.businessCertAmendDate">{{
                appendixChange.businessCertAmendDate | formatDate
              }}</span
              ><span v-else>.../.../.......</span></mark
            >
          </p>

          <ol>
            <li
              v-if="
                appendixChange.businessAuthoriserName ||
                appendixChange.businessAuthoriserMobile ||
                appendixChange.businessAuthoriserEmail ||
                appendixChange.businessPosition ||
                appendixChange.businessAuthoriserPassport
              "
            >
              <span class="txt-bold">
                Thông tin Người đại diện theo pháp luật của Doanh nghiệp/Chủ hộ kinh doanh
              </span>
              <div class="table-responsive p-r-60">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th><b>Nội dung</b></th>
                      <th><b>Thông tin hiện tại</b></th>
                      <th><b>Thông tin thay đổi</b></th>
                      <th><b>Lưu ý (nếu có)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="txt-center" v-if="appendixChange.businessAuthoriserName">
                      <td class="txt-center">Họ và tên</td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserName.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserName.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.businessAuthoriserMobile">
                      <td class="txt-center">Số điện thoại</td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserMobile.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserMobile.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.businessAuthoriserEmail">
                      <td class="txt-center">Email</td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserEmail.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserEmail.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.businessPosition">
                      <td class="txt-center">Chức danh</td>
                      <td class="txt-center">
                        {{ appendixChange.businessPosition.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessPosition.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.businessAuthoriserPassport">
                      <td class="txt-center">CMND/CCCD</td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserPassport.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessAuthoriserPassport.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="margin-top: 10px" v-if="appendixChange.businessMutualRelation">
                - Mối quan hệ giữa Người đại diện hiện tại và Người đại diện mới : [
                <mark>{{ appendixChange.businessMutualRelation }}</mark> ]
              </div>
            </li>

            <li
              v-if="
                appendixChange.businessMcName ||
                appendixChange.businessAddress ||
                appendixChange.businessOther
              "
            >
              <span class="txt-bold">
                Thông tin Doanh nghiệp/Hộ kinh doanh: Tên cty, địa điểm trên ĐKKD (Liên quan đến
                thẩm định và xuất hóa đơn)
              </span>
              <div class="table-responsive p-r-60">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th><b>Nội dung</b></th>
                      <th><b>Thông tin hiện tại</b></th>
                      <th><b>Thông tin thay đổi</b></th>
                      <th><b>Lưu ý (nếu có)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="txt-center" v-if="appendixChange.businessMcName">
                      <td class="txt-center">
                        Tên doanh nghiệp/ <br />
                        Hộ kinh doanh
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessMcName.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessMcName.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.businessAddress">
                      <td class="txt-center">Địa chỉ trụ sở</td>
                      <td class="txt-center">
                        {{ appendixChange.businessAddress.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessAddress.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                    <tr class="txt-center" v-if="appendixChange.businessOther">
                      <td class="txt-center">
                        Khác (nếu có, vui lòng <br />
                        điền chi tiết)
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessOther.oldData | checkEmpty }}
                      </td>
                      <td class="txt-center">
                        {{ appendixChange.businessOther.newData | checkEmpty }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ol>
        </li>
        <li>
          <ol class="form-style2">
            <p>
              <i
                >Lưu ý:
                <p>
                  -
                  <i
                    >ĐVCNTT cam kết chịu trách nhiệm trước
                    {{
                      checkCreatedDateNganluong(dataAppendix)
                        ? 'Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng'
                        : 'Công ty Cổ phần Công nghệ Vi Mô'
                    }}
                    và hoàn toàn chịu trách nhiệm trước pháp luật về tính chính xác và hợp pháp của
                    các thông tin kê khai.</i
                  >
                </p>
                <p>
                  -
                  <i
                    >Trong vòng 07 (bảy) ngày làm việc kể từ ngày
                    {{
                      checkCreatedDateNganluong(dataAppendix)
                        ? 'Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng'
                        : 'Công ty Cổ phần Công nghệ Vi Mô'
                    }}
                    nhận được Giấy Đề nghị thay đổi thông tin, nếu
                    {{
                      checkCreatedDateNganluong(dataAppendix)
                        ? 'Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng'
                        : 'Công ty Cổ phần Công nghệ Vi Mô'
                    }}
                    không có ý kiến phản hồi thì thông tin thay đổi sẽ được tự động áp dụng.</i
                  >
                </p>
              </i>
            </p>
          </ol>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  import { CommonService } from '@/services/common.service'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        configInfoChange: {},
        currentDate: new Date().toLocaleDateString('vi-VN'),
        bankConfig: [
          'VNCB - NH TNHH MTV XÂY DỰNG VN',
          'CTB - CITIBANK - NH CITI',
          'IBK - NH CÔNG NGHIỆP HÀN QUỐC CN VN',
          'SMB - SUMITOMO MITSUI BANKING CORPORATION',
        ],
      }
    },
    created() {
      CommonService.getConfigInfoChange().then(data => {
        if (data.success) {
          this.configInfoChange = data.data
        }
      })
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixChange.find(e => e.isCreatedWithContract)
        )
      },
      appendixChange() {
        return this.appendix.appendixChange ?? this.dataContract.lstAppendixChange.appendixChange
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css">
  .form-style1 h1::before {
    counter-increment: none !important;
    content: none !important;
  }

  h1::before {
    counter-increment: none !important;
    content: none !important;
  }
</style>
